import React, { useState, useRef, useEffect } from 'react';
import s from './Mfa.module.sass';

const SmsCodeForm = ({ onFilled, autoFocus = false }) => {  
  const [digits, setDigits] = useState(['', '', '', '', '', '']);
  const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  
  // Auto-focus first input when shown
  useEffect(() => {
    if (autoFocus && inputRefs[0].current) {
      const timer = setTimeout(() => {
        inputRefs[0].current?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [autoFocus]);
  
  const handleDigitChange = (index, value) => {
    // Only allow single digits
    if (value && !/^\d$/.test(value)) return;
    
    const newDigits = [...digits];
    newDigits[index] = value;
    setDigits(newDigits);
    
    // Auto-focus next input
    if (value && index < 5 && inputRefs[index + 1].current) {
      inputRefs[index + 1].current.focus();
    }
    
    // Check if all digits are filled and call callback onFilled
    const isComplete = newDigits.every(digit => digit !== '');
    if (onFilled) {
      if (isComplete) {
        onFilled(newDigits.join(''));
      } else {
        onFilled(false);
      }
    }
  };
  
  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0 && inputRefs[index - 1].current) {
      inputRefs[index - 1].current.focus();
    }
  };
  
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (pastedData) {
      const newDigits = [...digits];
      for (let i = 0; i < pastedData.length && i < 6; i++) {
        newDigits[i] = pastedData[i];
      }
      setDigits(newDigits);
      
      // Focus the next empty input or the last one
      const nextIndex = Math.min(pastedData.length, 5);
      if (inputRefs[nextIndex].current) {
        inputRefs[nextIndex].current.focus();
      }
      
      // Check if complete
      const isComplete = newDigits.every(digit => digit !== '');
      if (onFilled) {
        onFilled(isComplete ? newDigits.join('') : false);
      }
    }
  };
  
  return (
    <div className={s.digitContainer}>
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={inputRefs[index]}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength="1"
          value={digit}
          className={s.digitInput}
          onChange={(e) => handleDigitChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          aria-label={`Digit ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default SmsCodeForm;